import { C } from "@angular/cdk/keycodes";
import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import * as moment from "moment";
import { from, mergeMap, Subscription } from "rxjs";
import { ConvertDatetimePipe } from "../../../app/convert-datetime.pipe";
import { BaseUrlConstantsService } from "../../../app/services/base-url-constants.service";
import { PowerTrainService } from "../../../app/services/powertrain.service";
import { DialogOverviewExampleDialogComponent } from "../../dialog-overview-example-dialog/dialog-overview-example-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-powertrain-alerts",
  templateUrl: "./powertrain-alerts.component.html",
  styleUrls: ["./powertrain-alerts.component.scss"],
  standalone: true,
  imports: [CommonModule]
})
export class PowertrainAlertsComponent implements OnInit,OnDestroy {
  constructor(
    private service: PowerTrainService,
    private router: Router,
     public dialog: MatDialog,
  ) {}
  @Input("assetInventoryIds") idsData = [];
  @Input("client_id") client_id: string | number;
  @Input("subsystem_id") subsystem_id: number | string;
  sensorAlertsUrl = BaseUrlConstantsService.BASE_ALERT_URL;
  oldParamsSubscription = new Subscription();
  oldParams: any = null;
  selectedFFTUID: any;
  ngOnInit(): void {
    this.fetchSensorsLatestData(); // Fetch sensor data when the component initializes

    this.oldParamsSubscription = this.service.oldDashboardParamsObs.subscribe(
      (params) => {
        this.oldParams = JSON.parse(params)[0];
        console.log(JSON.parse(params));
      }
    );
  }

  ngOnDestroy(): void {
    this.oldParamsSubscription.unsubscribe();
  }
  alerts = [];
  isEmpty = false;

  fetchSensorsLatestData() {
    // Use RxJS `from` to convert the array into an observable stream
    from(this.idsData)
      .pipe(
        mergeMap((item) =>
          this.service
            .fetchSensorAlerts(
              `${this.sensorAlertsUrl}alert/errors/${this.client_id}/${item.inventory_id}/${item.asset_id}/${item.mac_address}`
            )
            .then((data: any) => {
              let errors = data.data.body.errors;
              if (errors.length > 0) {
                errors = errors.map((err) => {
                  let testDateUtc = moment.utc(err.time);
                  let localDate = testDateUtc.local();
                  let timeUpdatedAt = new ConvertDatetimePipe().convertDateTime(
                    localDate
                  );
                  return {
                    ...err,
                    time: timeUpdatedAt,
                    sensor_no: item.sensor_no,
                    sensor_marker: item.sensor_marker,
                    asset_id: item.asset_id,
                  };
                });
                this.alerts.push(...errors);
              }
            }) // Attach the fetched sensor data to the current item
            .catch((err) => {
              console.error(`Error fetching data for ${item.asset_id}`, err);
            })
        )
      )
      .subscribe({
        error: (err) => {
          console.error("Error during data fetching:", err);
        },
        complete: () => {
          console.log("All API calls completed.");
          this.alerts.length === 0
            ? (this.isEmpty = true)
            : (this.isEmpty = false);
        },
      });
  }

  taketopredominantalert(event, raw_matric_id) {
    this.selectedFFTUID = raw_matric_id;
    // let id = "tab-2";
    // this.ctdTabset.select(id);
    // this.loadFftData(this.selectedFFTUID, "pre");
  }
  openFftTime(fft) {
    console.log(fft);
    this.selectedFFTUID = fft.device_raw_matric_id;
    this.onSensorClick(fft)

  }
  onSensorClick(sensor) {
    console.log(sensor);
    console.log(this.oldParams);
    let allChild = this.oldParams;
    let sensorData = this.oldParams.connected_sensors.filter(
      (s) => s.id == sensor.asset_id
    )[0];
    localStorage.setItem("MacAddress", sensorData.mac_address);
    const assetChilds = allChild.connected_sensors.filter((x) => {
      return x.device_sno != 1;
    });
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        pageRef: "",
        deviceId: sensorData.inventory_id,
        assetid: sensorData.id,
        label: sensorData.lbl,
        asset_type: sensorData.asset_type,
        sub_type: allChild.sub_type,
        device_serial_no: sensorData.device_sno,
        serial_no: sensorData.sno,
        assetStatus: sensorData.asset_status,
        sensorType: sensorData.sensor,
        no_of_children: assetChilds.length,
        asset_master_info: JSON.stringify(allChild),
        macaddress: sensorData.mac_address,
        kurt_freq: allChild.kurt_freq,
        kurt_threshold: allChild.kurt_threshold,
        kurt_anomaly_counter: allChild.kurt_anomaly_counter,
        route_path: "device-reports",
        outOfService: allChild.out_of_service,
        motor_serial_no: sensorData.motor_serial_no,
        fromPowerTrain: JSON.stringify({
          subsystemId: this.subsystem_id,
          isPowertrainSensor: true,
          fft_id: this.selectedFFTUID
        }),
      },
    };
    const params = new URLSearchParams({
      Monitoring_window: 'true',
    });
    // this.userID === "390" || this.clientId === "390"
    if (this.client_id == "390" || localStorage.getItem("associated_clientid")=='390') {
    localStorage.removeItem("innertab");
    localStorage.removeItem("tab")
      // console.log(navigationExtras.queryParams)
      const newWindowUrl = `/#/detail-nxt?${params}`;

      const newWindow = window.open(newWindowUrl, '_blank');

      if (newWindow) {
        newWindow.addEventListener('load', () => {
          newWindow.postMessage({ type: 'passData', data: navigationExtras }, window.location.origin);

          // Send the second message after a delay
          setTimeout(() => {
            newWindow.postMessage({ type: 'passData', data: navigationExtras }, window.location.origin);
          }, 1000); 

        });
      } else {
        console.error('Failed to open new tab. Pop-up blocker may be enabled.');
      }
    } else {

      this.router.navigate(['detail-nxt'], navigationExtras);

    }
  }

    OnClickAlert(report) {
      console.log(report)
      const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
        width: "400px",
        maxWidth: "85vw",
        data: {
          type: "AlertBookOpen",
          data: {
            assetid: report.asset_id,
            clientid: this.client_id,
            report: report,
          },
        },
      });
    }
}
